import { SUPER_ADMIN_API_ENDPOINTS, SUPER_ADMIN_API_URL } from "../../../constants";
import superAdminAxiosInstance from "../../../core/apiService/superAdminApiService";

const fetchMemberShipLists = async (
    { networkTypeId, name , isActive }: { networkTypeId:any;name:any; isActive:any },
    token: string
  ): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.get(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_MEMBERSHIP_LIST}?network_type_id=${networkTypeId}&name=${name}&is_active=${isActive}`
    );
    return response.data;
};

const createMembershipPLan = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.post(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.CREATE_PLAN}`,
      payload,
    );
    return response.data;
};

const updateMembershipPLan = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.put(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.UPDATE_PLAN}?plan_id=${payload?.planID}`,
      payload?.payload,
    );
    return response.data;
};

const deleteMembershipPLan = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.delete(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.DELETE_PLAN}`,
      { data: payload, ...config },
    );
    return response.data;
};

const fetchFeaturesList = async (
    { networkTypeId }: { networkTypeId:any },
    token: string
  ): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.get(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_FEATURE_LISTS}?network_type_id=${networkTypeId}`
    );
    return response.data;
};

const createPlanFeature = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.post(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.CREATE_FEATURE}`,
      payload
    );
    return response.data;
};

const updatePlanFeature = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.put(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.UPDATE_FEATURE}?feature_id=${payload?.feature_id}`,
      payload
    );
    return response.data;
};

const deletePlanFeature = async (payload: any, token: string): Promise<any> => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await superAdminAxiosInstance.delete(
      `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.DELETE_FEATURE}`,
      { data: payload, ...config }
    );
    return response.data;
};

// NEW: fetch single plan details
const fetchPlanDetails = async (
  { planId, networkTypeId }: { planId: any; networkTypeId: any },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBERSHIP_MANAGEMENT.FETCH_PLAN_DETAILS}?plan_id=${planId}&network_type_id=${networkTypeId}`
  );
  return response.data;
};


const superAdminMembershipManagementService = {
    fetchMemberShipLists,
    createMembershipPLan,
    updateMembershipPLan,
    deleteMembershipPLan,
    fetchFeaturesList,
    createPlanFeature,
    updatePlanFeature,
    deletePlanFeature,
    fetchPlanDetails
};

export default superAdminMembershipManagementService;
